import { render, staticRenderFns } from "./drugHistory.vue?vue&type=template&id=693aa0f0&scoped=true"
import script from "./drugHistory.vue?vue&type=script&lang=js"
export * from "./drugHistory.vue?vue&type=script&lang=js"
import style0 from "./drugHistory.vue?vue&type=style&index=0&id=693aa0f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693aa0f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693aa0f0')) {
      api.createRecord('693aa0f0', component.options)
    } else {
      api.reload('693aa0f0', component.options)
    }
    module.hot.accept("./drugHistory.vue?vue&type=template&id=693aa0f0&scoped=true", function () {
      api.rerender('693aa0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcDrugList/drugHistory.vue"
export default component.exports